export abstract class ActionViewPersistenceService {
    // I very lazily ported these over; anything I could tell the type of at a glance I provided
    // a type for, otherwise used any. We should put in proper types at some point, but for now
    // this gets us TS support
    routeParams: any;
    filterColumns: any;
    outputColumns: any[];
    detailResults: any;
    overviewResults: any;
    overviewHeaders: any[];
    drilldownMode: boolean;
    resultsChanged: boolean;
    selectedResult: any;
    actionViewType: any;
    actionViewName: string;
    masterFilter: any;
    drilldownFilter: any;
    showOrs: boolean;
    organizeBySelection: number;
    groupByCount: number;
    externalDrilldown: boolean;
    externalDrilldownData: any;
    noAppealRevisionChangeTypeID: number;
    noAppealRevisionDescription: string;
    appealWarrantedRevisionChangeTypeID: number;
    appealWarrantedRevisionDescription: string;
    selectionData: any[];
    sort: any;
    filter: any;
    columnState: any;

    abstract clearSavedData(): void;
}
